import resetPasswordActions from './actions';
import { createReducer } from '../../helpers/reducer';
import { keyBy } from '../../helpers/core';

// ------------------------------
// Local util functions
// ------------------------------
function validate({ attr, value = '', newPasswordValue = '' }) {
  let error = '';
  const defaultErrorMessage =
    'Your password must be at least 7 characters and include upper and lower case, and at least 1 special character.';
  const notEqualPassErrorMessage = 'Your passwords are not equal';

  if (attr === 'confirmPassword' || attr === 'newPassword') {
    if (!value || value.length < 7) {
      error = defaultErrorMessage;
    }
    if (value && !/[a-z]/.test(value)) {
      error = defaultErrorMessage;
    }
    if (value && !/[A-Z]/.test(value)) {
      error = defaultErrorMessage;
    }
    if (value && !/\W/.test(value)) {
      error = defaultErrorMessage;
    }
  }

  if (attr === 'confirmPassword') {
    if (value !== newPasswordValue) {
      error = notEqualPassErrorMessage;
    }
  }

  return error;
}

// ------------------------------
// Initial State
// ------------------------------
const initState = {
  newPassword: {
    value: '',
    error: validate({ attr: 'newPassword' }),
    name: 'newPassword',
    touched: false,
  },
  confirmPassword: {
    value: '',
    error: validate({ attr: 'confirmPassword' }),
    name: 'confirmPassword',
    touched: false,
  },
  isSaveloader: false,
  saved: false,
  globalError: '',
};

// ------------------------------
// Action Handlers
// ------------------------------
function onChangeProperty(state, { payload }) {
  const { attr, value } = payload;
  const newPasswordValue = state.newPassword.value;

  state[attr] = {
    value,
    error: validate({ attr, value, newPasswordValue }),
    name: attr,
    touched: true,
  };

  return { ...state };
}

function onTouch(state, { payload }) {
  const { props } = payload;
  const propsArray = props.map(prop => state[prop]);

  const updatedState = keyBy(
    propsArray,
    prop => prop.name,
    prop => ({ ...prop, touched: true }),
  );

  return { ...state, ...updatedState };
}

function onResetPasswordSuccess(state) {
  return { ...state, isSaveloader: false, saved: true };
}

function onResetPasswordError(state, { payload }) {
  const { errors } = payload;

  const { oldPassword } = state;
  state[errors[0].field] = {
    value: oldPassword.value,
    error: errors[0].message,
    name: errors[0].field,
    touched: true,
  };

  return { ...state, isSaveloader: false };
}

function onResetPasswordRequest(state) {
  return { ...state, isSaveloader: true };
}

function onClearState() {
  return { ...initState };
}

function onThrowError(state, { payload }) {
  const { error } = payload;
  return { ...state, globalError: error };
}

// ------------------------------
// Exported reducer function.
// ------------------------------
export default createReducer(initState, {
  [resetPasswordActions.CHANGE_PROPERTY]: onChangeProperty,
  [resetPasswordActions.TOUCH]: onTouch,
  [resetPasswordActions.CLEAR_STATE]: onClearState,
  [resetPasswordActions.RESET_PASSWORD_SUCCESS]: onResetPasswordSuccess,
  [resetPasswordActions.RESET_PASSWORD_ERROR]: onResetPasswordError,
  [resetPasswordActions.RESET_PASSWORD_REQUEST]: onResetPasswordRequest,
  [resetPasswordActions.THROW_ERROR]: onThrowError,
});
